const isDbStatsLoading = (state) => state.isDbStatsLoading;
const numDocuments = (state) => state.numDocuments;
const notificationDocs = (state) => state.notificationDocs;

const isRssFeedsLoading = (state) => state.isRssFeedsLoading;
const numRssUpdates = (state) => state.numRssUpdates;
const rssFeeds = (state) => state.feeds;

const notificationPrefs = (state) => state.notificationPrefs;

export const getters = {
  isDbStatsLoading,
  numDocuments,
  notificationDocs,
  isRssFeedsLoading,
  numRssUpdates,
  rssFeeds,
  notificationPrefs,
};
